import { Component, Input } from '@angular/core';
import { RouteSheetLocationDTO } from '../../../organisms/route-sheet/models/RouteSheetLocationDTO';
import { RouteSheetService } from '../../../organisms/route-sheet/service/RouteSheet.service';

@Component({
  selector: "route-sheet-generic-card",
  templateUrl: "./generic-card.component.html",
  styleUrls: ["./generic-card.component.css"],
})
export class RouteSheetGenericCardComponent {
  @Input() routeSheetLocation: RouteSheetLocationDTO;
  @Input() skeletonLoading: boolean = false;

  constructor(private routeSheetService: RouteSheetService) {}
}
